import { useLang } from '../i18n.ts';
import { Alert, ErrorAlert } from './ui.tsx';
import type { FormErrors } from './useFormErrors.ts';

/**
 * The alerts at the top of a form: a short "not saved" alert naming every field with an error
 * (owner feedback, D97), then whatever the server said that is not already under a field.
 * `action` = "sent" for forms that do not save anything (sign-in, codes).
 */
export function FormAlerts({
  errors,
  action = 'saved',
}: {
  readonly errors: FormErrors;
  readonly action?: 'saved' | 'sent';
}) {
  const { t, lang } = useLang();
  return (
    <>
      {errors.summary.length > 0 ? (
        <Alert tone="error">
          <p className="font-bold">
            {action === 'saved' ? t('common.formNotSaved') : t('common.formNotSent')}
          </p>
          <p className="mt-1">
            {t('common.formFieldsList', {
              fields: errors.summary.join(lang === 'ar' ? '، ' : ', '),
            })}
          </p>
        </Alert>
      ) : null}
      <ErrorAlert error={errors.alertError} shownUnderFields={errors.fields} />
    </>
  );
}
